
import {
  CATEGORYS_UPDATE_FAILURE,
  CATEGORYS_UPDATE_REQUEST,
  CATEGORYS_UPDATE_SUCCESS,
  CATEGORYS_REQUEST,
  CATEGORYS_SUCCESS,
  CATEGORYS_FAILURE,
  ADD_CATEGORYS_REQUEST,
  ADD_CATEGORYS_SUCCESS,
  ADD_CATEGORYS_FAILURE,
  DELETE_CATEGORYS_REQUEST,
  DELETE_CATEGORYS_SUCCESS,
  DELETE_CATEGORYS_FAILURE,
  UPDATE_BRAND_REQUEST,
  UPDATE_BRAND_SUCCESS,
  UPDATE_BRAND_FAILURE,
  CATEGORY_VARIANT_FAILURE,
  CATEGORY_VARIANT_REQUEST,
  CATEGORY_VARIANT_SUCCESS,
  ADD_CATEGORY_VARIANT_FAILURE,
  ADD_CATEGORY_VARIANT_SUCCESS,
  ADD_CATEGORY_VARIANT_REQUEST,
  DELETE_CATEGORY_VARIANT_FAILURE,
  DELETE_CATEGORY_VARIANT_REQUEST,
  DELETE_CATEGORY_VARIANT_SUCCESS,
  CATEGORY_VARIANT_VALUE_FAILURE,
  CATEGORY_VARIANT_VALUE_REQUEST,
  CATEGORY_VARIANT_VALUE_SUCCESS,
  ADD_CATEGORY_VARIANT_VALUE_FAILURE,
  ADD_CATEGORY_VARIANT_VALUE_SUCCESS,
  ADD_CATEGORY_VARIANT_VALUE_REQUEST,
  DELETE_CATEGORY_VARIANT_VALUE_FAILURE,
  DELETE_CATEGORY_VARIANT_VALUE_REQUEST,
  DELETE_CATEGORY_VARIANT_VALUE_SUCCESS
} from './actionTypes';

import categoryService from '../../services/categoryService';

// Kategorileri listeleme
export const categoryRequest = () => ({
  type: CATEGORYS_REQUEST,
});

export const categorySuccess = (user) => ({
  type: CATEGORYS_SUCCESS,
  payload: user,
});

export const categoryPlacesFailure = (error) => ({
  type: CATEGORYS_FAILURE,
  payload: error,
});

export const getCategories = (token) => {

  return async (dispatch) => {
    dispatch(categoryRequest());
    try {
      const response = await categoryService.getCategoriesApi(token);
      dispatch(categorySuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(categoryPlacesFailure(error.response?.data || 'kategoriler bulunamadı!'));
      throw error;
    }
  };
  
};
///////////////////////////

// Kategorileri veri tabanına ekleme
export const addCategoryRequest = () => ({
  type: ADD_CATEGORYS_REQUEST,
});

export const addCategorySuccess = (user) => ({
  type: ADD_CATEGORYS_SUCCESS,
  payload: user,
});

export const addCategoryFailure = (error) => ({
  type: ADD_CATEGORYS_FAILURE,
  payload: error,
});

export const addCategory = (data,token) => {

  return async (dispatch) => {
    dispatch(addCategoryRequest());
    try {
      const response = await categoryService.addCategoryApi(data,token);
      dispatch(addCategorySuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(addCategoryFailure(error.response?.data || 'kategoriler EKLENEMEDİ!'));
      throw error;
    }
  };
  
};
/////////////////////

// KATEGORİ SİLME
export const deleteCategoryRequest = () => ({
  type: DELETE_CATEGORYS_REQUEST,
});

export const deleteCategorySuccess = (user) => ({
  type: DELETE_CATEGORYS_SUCCESS,
  payload: user,
});

export const deleteCategoryFailure = (error) => ({
  type: DELETE_CATEGORYS_FAILURE,
  payload: error,
});

export const deleteCategory= (id,token) => {

  return async (dispatch) => {
    dispatch(deleteCategoryRequest());
    try {
      const response = await categoryService.deleteCategoryApi(id,token);
      dispatch(deleteCategorySuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(deleteCategoryFailure(error.response?.data || 'kategoriler silinemedi!'));
      throw error;
    }
  };
  
};


// KATEGORİ GÜNCELLE
export const updateCategoryRequest = () => ({
  type: UPDATE_BRAND_REQUEST,
});

export const updateCategorySuccess = (user) => ({
  type: UPDATE_BRAND_SUCCESS,
  payload: user,
});

export const updateCategoryFailure = (error) => ({
  type: UPDATE_BRAND_FAILURE,
  payload: error,
});

export const updateCategory= (data,token) => {
  return async (dispatch) => {
    dispatch(updateCategoryRequest());
    try {
      const response = await categoryService.updateCategoryApi(data,token);
      dispatch(updateCategorySuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(updateCategoryFailure(error.response?.data || 'kategoriler silinemedi!'));
      throw error;
    }
  };
  
};



export const addCategoryVaiant = (categoryVariantData,token) => {
  return async (dispatch) => {
    dispatch({ type: ADD_CATEGORY_VARIANT_REQUEST });
    try {
      const response = await categoryService.addCategoryVariantApi(categoryVariantData,token);
      const payload = response?.data?.data ?? response?.data;
      dispatch({ type: ADD_CATEGORY_VARIANT_SUCCESS, payload });
      return payload; 
    } catch (error) {
      dispatch({ type: ADD_CATEGORYS_FAILURE, error: error.message });
      return Promise.reject(error); 
    }
  };
};

export const deleteCategoryVaiant = (providerData,token) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_CATEGORY_VARIANT_REQUEST });
    try {
      const response = await categoryService.deleteCategoryVariantApi(providerData,token);
      const payload = response?.data?.data ?? response?.data;
      dispatch({ type: DELETE_CATEGORY_VARIANT_SUCCESS, payload });
      return payload; 
    } catch (error) {
      dispatch({ type: DELETE_CATEGORY_VARIANT_FAILURE, error: error.message });
      return Promise.reject(error); 
    }
  };
};


export const getCategoryVaiant = (userId,token,page,pageSize,name,closePagination) => {
  return async (dispatch) => {
    dispatch({ type: CATEGORY_VARIANT_REQUEST });
    try {

      const response = await categoryService.getCategoriyVariantApi(userId,token,page,pageSize,name,closePagination);
      const envelope = response?.data;
      const table = envelope?.data;
      const data = Array.isArray(table?.data)
        ? table.data
        : Array.isArray(table)
          ? table
          : Array.isArray(envelope?.data)
            ? envelope.data
            : [];
      const recordsTotal = table?.recordsTotal ?? data.length;
      const payload = { data, recordsTotal };

      dispatch({ type: CATEGORY_VARIANT_SUCCESS, payload });
      return payload;
    } catch (error) {
      dispatch({ type: CATEGORY_VARIANT_FAILURE, error: error.message });
      return Promise.reject(error);
    }
  };
};


// Varyant DEĞER eşleştirmeleri - getCategoryVaiant/addCategoryVaiant/deleteCategoryVaiant ile aynı desen
export const addCategoryVariantValue = (categoryVariantValueData,token) => {
  return async (dispatch) => {
    dispatch({ type: ADD_CATEGORY_VARIANT_VALUE_REQUEST });
    try {
      const response = await categoryService.addCategoryVariantValueApi(categoryVariantValueData,token);
      const payload = response?.data?.data ?? response?.data;
      dispatch({ type: ADD_CATEGORY_VARIANT_VALUE_SUCCESS, payload });
      return payload;
    } catch (error) {
      dispatch({ type: ADD_CATEGORY_VARIANT_VALUE_FAILURE, error: error.message });
      return Promise.reject(error);
    }
  };
};

export const deleteCategoryVariantValue = (id,token) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_CATEGORY_VARIANT_VALUE_REQUEST });
    try {
      const response = await categoryService.deleteCategoryVariantValueApi(id,token);
      const payload = response?.data?.data ?? response?.data;
      dispatch({ type: DELETE_CATEGORY_VARIANT_VALUE_SUCCESS, payload });
      return payload;
    } catch (error) {
      dispatch({ type: DELETE_CATEGORY_VARIANT_VALUE_FAILURE, error: error.message });
      return Promise.reject(error);
    }
  };
};

export const getCategoryVariantValue = (placeCategoryVariantId,token) => {
  return async (dispatch) => {
    dispatch({ type: CATEGORY_VARIANT_VALUE_REQUEST });
    try {
      const response = await categoryService.getCategoryVariantValueApi(placeCategoryVariantId,token);
      const envelope = response?.data;
      const table = envelope?.data;
      const payload = Array.isArray(table?.data)
        ? table.data
        : Array.isArray(table)
          ? table
          : Array.isArray(envelope?.data)
            ? envelope.data
            : [];

      dispatch({ type: CATEGORY_VARIANT_VALUE_SUCCESS, payload });
      return payload;
    } catch (error) {
      dispatch({ type: CATEGORY_VARIANT_VALUE_FAILURE, error: error.message });
      return Promise.reject(error);
    }
  };
};

